var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"intro html",domProps:{"innerHTML":_vm._s(require('./intro.md'))}})}
var staticRenderFns = []

export { render, staticRenderFns }